import script from "./gst.vue?vue&type=script&setup=true&lang=ts"
export * from "./gst.vue?vue&type=script&setup=true&lang=ts"

import "./gst.vue?vue&type=style&index=0&id=5fd658d1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fd658d1"]])

export default __exports__